
// Converted from Prepros directive
import './modules/gallery.js';

$(function () {
});
